"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("../../Components/styles/color"));
var _NativeAvatar = _interopRequireDefault(require("../../Components/NativeAvatar"));
var _Text = _interopRequireDefault(require("../../SharedComponents/Typography/Text"));
var _Tooltip = _interopRequireWildcard(require("../Feedback/Tooltip"));
var _useFeedbackStates3 = _interopRequireDefault(require("../helper/useFeedbackStates"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var SimpleItemContainer = _styledComponents["default"].div.withConfig({
  displayName: "SimpleItemContainer",
  componentId: "sc-13mia8l-0"
})(["display:flex;width:100%;min-width:80px;align-items:center;padding:8px;height:56px;cursor:pointer;background-color:", ";box-shadow:", ";:hover{box-shadow:", ";z-index:5;}"], function (props) {
  return props.background || 'transparent';
}, function (props) {
  return props.folderHoverShadow && !props.isHover ? "inset 0px -1px 0px ".concat(_color["default"].lightPrimary) : "inset 0px -1px 0px ".concat(_color["default"].grey200);
}, function (props) {
  return props.folderHoverShadow ? "inset 0px 0px 0px ".concat(_color["default"].info) : '';
});
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-13mia8l-1"
})(["display:flex;margin-right:8px;"]);
var TextContainer = _styledComponents["default"].div.withConfig({
  displayName: "TextContainer",
  componentId: "sc-13mia8l-2"
})(["display:flex;min-width:60px;"]);
var DescriptionContainer = _styledComponents["default"].div.withConfig({
  displayName: "DescriptionContainer",
  componentId: "sc-13mia8l-3"
})(["display:flex;margin-right:8px;margin-left:auto;"]);
var ListItem = function ListItem(_ref) {
  var label = _ref.label,
    icon = _ref.icon,
    iconColor = _ref.iconColor,
    userName = _ref.userName,
    contentType = _ref.contentType,
    description = _ref.description,
    tooltipLabel = _ref.tooltipLabel,
    tooltipPosition = _ref.tooltipPosition,
    alwaysShowTooltip = _ref.alwaysShowTooltip,
    onClick = _ref.onClick,
    darkTheme = _ref.darkTheme,
    customCircleColor = _ref.customCircleColor,
    customBackgroundColor = _ref.customBackgroundColor,
    folderHoverShadow = _ref.folderHoverShadow,
    payload = _ref.payload,
    spin = _ref.spin;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var containerRef = (0, _react.useRef)(null);
  var textRef = (0, _react.useRef)(null);
  var _useFeedbackStates = (0, _useFeedbackStates3["default"])(containerRef),
    _useFeedbackStates2 = _slicedToArray(_useFeedbackStates, 2),
    isHover = _useFeedbackStates2[0],
    isPressed = _useFeedbackStates2[1];
  var checkSize = function checkSize() {
    if (textRef.current && containerRef.current) {
      var textRect = textRef.current.getBoundingClientRect();
      var containerRect = containerRef.current.getBoundingClientRect();

      // check if right position of text has reached container end minus padding
      var hasOverflowingChildren = containerRect.right - textRect.right <= 8;
      setShowTooltip(hasOverflowingChildren);
    }
  };

  /* eslint-disable */
  (0, _react.useEffect)(function () {
    checkSize();
    window.addEventListener('resize', checkSize);
    return function () {
      window.removeEventListener('resize', checkSize);
    };
  }, []);
  /* eslint-enable */

  // return onHover and onPress color if onClick prop exists
  var getBackgroundColor = function getBackgroundColor() {
    if (onClick) {
      return isPressed ? _color["default"].grey200 : isHover ? _color["default"].grey50 : customBackgroundColor || _color["default"].white;
    }
    return customBackgroundColor || null;
  };
  var callOnClick = function callOnClick(e) {
    if (onClick) {
      e.stopPropagation();
      onClick(payload);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(SimpleItemContainer, {
    folderHoverShadow: folderHoverShadow,
    isHover: isHover,
    ref: containerRef,
    background: getBackgroundColor(),
    onClick: callOnClick
  }, (icon || contentType || userName) && /*#__PURE__*/_react["default"].createElement(IconContainer, null, /*#__PURE__*/_react["default"].createElement(_NativeAvatar["default"], {
    size: 40,
    fontSize: "p",
    icon: icon,
    customCircleColor: customCircleColor,
    iconColor: iconColor,
    userName: userName,
    contentType: contentType,
    appBrandColor: iconColor,
    spin: spin || false
  })), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    label: tooltipLabel || label,
    position: tooltipPosition || _Tooltip.TooltipPosition.TOP_LEFT,
    hidden: !alwaysShowTooltip && !showTooltip
  }, /*#__PURE__*/_react["default"].createElement(TextContainer, {
    ref: textRef
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    text: label,
    textSize: "p",
    fontColor: darkTheme ? _color["default"].lightPrimary : _color["default"].grey800,
    ellipsis: true,
    numberOfLines: 1
  }))), description && /*#__PURE__*/_react["default"].createElement(DescriptionContainer, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    ellipsis: true,
    text: description,
    textSize: "h6",
    fontColor: iconColor
  })));
};
__signature__(ListItem, "useState{[showTooltip, setShowTooltip](false)}\nuseRef{containerRef}\nuseRef{textRef}\nuseFeedbackStates{[isHover, isPressed]}\nuseEffect{}", function () {
  return [_useFeedbackStates3["default"]];
});
var _default = ListItem;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(SimpleItemContainer, "SimpleItemContainer", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListItem.js");
  reactHotLoader.register(IconContainer, "IconContainer", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListItem.js");
  reactHotLoader.register(TextContainer, "TextContainer", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListItem.js");
  reactHotLoader.register(DescriptionContainer, "DescriptionContainer", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListItem.js");
  reactHotLoader.register(ListItem, "ListItem", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListItem.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/ListItem/ListItem.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();